import { formatPhoneMx, toPhoneDigits } from '@/lib/phoneMx';

export { toPhoneDigits, toPrefillPhone } from '@/lib/phoneMx';

/** "4422194128" → "442-219-4128": el wizard conserva los guiones. */
export function formatPhone(value: string): string {
    return formatPhoneMx(toPhoneDigits(value), '-');
}
